import CareerFoundationBanner from './CareerFoundationBanner'
export default CareerFoundationBanner
